// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__dWjtB","title":"ProductList_title__dHF7E","products":"ProductList_products__ad9NW"};